var module = angular.module('octopusApp.infrastructure');

module.factory('timeSpan', function($rootScope) {

  var create = function(ms) {
    var totalMilliseconds = ms;

    var rem = totalMilliseconds;

    var days = Math.floor(rem / (1000 * 60 * 60 * 24));
    rem -=  days * (1000 * 60 * 60 * 24);

    var hours = Math.floor(rem / (1000 * 60 * 60));
    rem -= hours * (1000 * 60 * 60);

    var minutes = Math.floor(rem / (1000 * 60));
    rem -= minutes * (1000 * 60);

    var seconds = Math.floor(rem / (1000));
    rem -= seconds * (1000);

    var milliseconds = Math.round(rem);

    var totalSeconds = function() {
      return totalMilliseconds / 1000;
    };

    var totalMinutes = function() {
      return totalSeconds() / 60;
    };

    var totalHours = function() {
      return totalMinutes() / 60;
    };

    var totalDays = function() {
      return totalHours() / 24;
    };

    var pad2 = function(str) {
      return '00'.concat(str).slice(-2);
    };

    var pad3 = function(str) {
      return '000'.concat(str).slice(-3);
    };

    var toString = function() {
      var result = '';
      if (days > 0) {
        result = result.concat(days.toString(), '.');
      }
      result = result.concat(pad2(hours), ':', pad2(minutes), ':', pad2(seconds));
      if (milliseconds !== 0) {
        result = result.concat('.', pad3(milliseconds));
      }
      return result;
    };

    return {
      totalDays: totalDays,
      totalHours: totalHours,
      totalMinutes: totalMinutes,
      totalSeconds: totalSeconds,
      totalMilliseconds: function() { return totalMilliseconds; },

      days: function() { return days; },
      hours: function() { return hours; },
      minutes: function() { return minutes; },
      seconds: function() { return seconds; },
      milliseconds: function() { return milliseconds; },

      toString: toString
    };
  };

  var parse = function(str) {
    var parts = str.split(':');

    var ms = parseFloat(parts[parts.length - 1] * 1000);

    if (parts.length === 2) {         // 00:00.000
      ms += parseInt(parts[0], 10) * 60 * 1000;
    } else if (parts.length === 3) { // 0.00:00:00.000
      var dh = parts[0].split('.');
      if (dh.length === 1) {
        ms += parseInt(parts[0], 10) * 60 * 60 * 1000;
      } else {
        ms += parseInt(dh[0], 10) * 24 * 60 * 60 * 1000;
        ms += parseInt(dh[1], 10) * 60 * 60 * 1000;
      }
      ms += parseInt(parts[1], 10) * 60 * 1000;
    } else {
      throw "Invalid TimeSpan string " + str;
    }

    return create(ms);
  };

  var fromMilliseconds = function(ms) {
    return create(ms);
  };

  var fromSeconds = function(s) {
    return create(s * 1000);
  };

  var fromMinutes = function(m) {
    return create(m * 60 * 1000);
  };

  return {
    fromMilliseconds: fromMilliseconds,
    fromSeconds: fromSeconds,
    fromMinutes: fromMinutes,

    parse: parse
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/time_span.js
// module id = 708
// module chunks = 1